module.exports = __webpack_public_path__ + "img/wild.2.3756dc6.jpg";